export default __webpack_public_path__ + "static/media/addNew.9435e1ff.svg";